import {controller} from '@github/catalyst'

@controller('commit-autofix-action')
class CommitAutofixActionElement extends HTMLElement {
  menuSelect(event: Event) {
    const selectedItem = event.currentTarget as HTMLElement
    const label = selectedItem.getAttribute('data-label')

    // Select the button by its ID as its already assigned a react-partial-anchor target
    const button = document.getElementById('suggested-fix-component-anchor') as HTMLButtonElement
    button.textContent = label
    button.setAttribute('data-branch-type', selectedItem.getAttribute('data-branch-type') || 'new')
  }

  openCreateBranchDialog() {
    document.dispatchEvent(new CustomEvent('openCreateBranchDialog'))
  }
}
